import { View } from 'react-native'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'

import { LinkedOrdersOption } from './types'
import OptionItem from './OptionItem'

interface Props {
  open: boolean
  close: () => void
  onSelect: (option: LinkedOrdersOption) => void
}

export default function LinkedOrdersModal({ open, close, onSelect }: Props) {
  const { t } = useTranslation(['modals', 'ui'])
  const text = `modals:checkout.linkedOrders`

  const handleSelect = useCallback(
    (option: LinkedOrdersOption) => {
      onSelect(option)
      close()
    },
    [onSelect, close]
  )

  return (
    <ModalBottom
      open={open}
      close={close}
      title={t(`${text}.title`)}
      desc={t(`${text}.desc`)}
      hideBottomSpace
      spacedText
    >
      <View className="flex w-full flex-col items-center gap-8 px-16 pb-16">
        <OptionItem onSelect={handleSelect} option="separately" />
        <OptionItem onSelect={handleSelect} option="together" />
      </View>
    </ModalBottom>
  )
}
